/* eslint-disable import/prefer-default-export */
const CloseChildMobileMenu = () => {
    const activeSecondLevelMenu = document.querySelectorAll('.active-second-level');
    activeSecondLevelMenu.forEach(activeSecondLevel => {
        activeSecondLevel.classList.remove('active-second-level');
    });
    const activeThirdLevelMenu = document.querySelectorAll('.active-third-level');
    activeThirdLevelMenu.forEach(activeThirdLevel => {
        activeThirdLevel.classList.remove('active-third-level');
    });
    const dispayingSublevel = document.querySelectorAll('.displaying-sublevel');
    dispayingSublevel.forEach(element => {
        element.classList.remove('displaying-sublevel');
    });
    const documentBody = document.querySelector('body');
    if (documentBody) {
        documentBody.classList.remove('no-overflow');
    }
};

const MobileHeaderButtonHandler = mobileHeader => {
    const headerMenuButton = document.querySelector('.mh-button-menu');
    const documentBody = document.querySelector('body');

    if (headerMenuButton) {
        headerMenuButton.addEventListener('click', e => {
            e.preventDefault();

            const headerMenuClass = 'mh-show-menu';
            const menuActiveClass = 'mh-menu-active';

            if (headerMenuButton.classList.contains(menuActiveClass)) {
                headerMenuButton.classList.remove(menuActiveClass);
                mobileHeader.classList.remove(headerMenuClass);
                CloseChildMobileMenu();
            } else {
                headerMenuButton.classList.add(menuActiveClass);
                mobileHeader.classList.add(headerMenuClass);
                if (documentBody) {
                    documentBody.classList.add('no-overflow');
                }
                const mobileSearchBox = document.querySelector('.mh-header-search-container');
                mobileSearchBox.classList.remove('is-active');
            }

            const headerSearchActiveMenuClass = 'mh-show-search';
            const activeSearchHeader = document.querySelector(`.mobile-header.${headerSearchActiveMenuClass}`);
            activeSearchHeader?.classList.remove(headerSearchActiveMenuClass);
        });
    }
};

export const CloseActiveMobileMenu = () => {
    const activeMobileMenu = document.querySelector('.mobile-header.mh-show-menu');
    const headerMenuButton = document.querySelector('.mh-button-menu.mh-menu-active');

    if (activeMobileMenu) {
        activeMobileMenu.classList.remove('mh-show-menu');
        headerMenuButton?.classList.remove('mh-menu-active');
        CloseChildMobileMenu();
    }

    const mobileSearchBox = document.querySelector('.mh-header-search-container');
    mobileSearchBox.classList.remove('is-active');
    const headerSearchActiveMenuClass = 'mh-show-search';
    const activeSearchHeader = document.querySelector(`.mobile-header.${headerSearchActiveMenuClass}`);
    activeSearchHeader?.classList.remove(headerSearchActiveMenuClass);
};

const MobileHeaderHandler = () => {
    const mobileHeader = document.querySelector('.mobile-header');
    const mobileFirstLevelButtons = document.querySelectorAll('.mh-first-level-item-link');
    const mobileSecondLevelBackButtons = document.querySelectorAll('.mh-second-level-back-button');
    const mobileSecondLevelButtons = document.querySelectorAll('.mh-second-level-item-link');
    const mobileThirdLevelBackButtons = document.querySelectorAll('.mh-third-level-back-button');

    const mobileSearchTrigger = document.querySelector('.mh-button-search');
    const mobileSearchBox = document.querySelector('.mh-header-search-container');

    const headerSearchActiveMenuClass = 'mh-show-search';

    mobileSearchTrigger?.addEventListener('click', () => {
        const activeMobileMenu = document.querySelector('.mobile-header.mh-show-menu');

        if (activeMobileMenu) {
            CloseActiveMobileMenu();
            mobileSearchBox.classList.toggle('is-active');
            mobileHeader.classList.toggle(headerSearchActiveMenuClass);
            document.querySelector('.mh-header-search-container .ais-SearchBox-reset').click();
        } else {
            mobileSearchBox.classList.toggle('is-active');
            mobileHeader.classList.toggle(headerSearchActiveMenuClass);
            if (mobileSearchBox.classList.contains('is-active')) {
                document.querySelector('.mh-header-search-container .ais-SearchBox-reset').click();
            }
        }
    });

    if (mobileHeader) {
        MobileHeaderButtonHandler(mobileHeader);
    }

    mobileFirstLevelButtons.forEach(firstLevelButton => {
        firstLevelButton.addEventListener('click', e => {
            e.preventDefault();
            const parentItem = firstLevelButton.parentElement;
            const secondLevelMenu = parentItem.querySelector('.mh-menu-dropdown-second-level');

            secondLevelMenu.classList.add('active-second-level');

            const firstLevelDropdownMenu = parentItem.closest('.mh-menu-dropdown-first-level');
            if (firstLevelDropdownMenu) {
                firstLevelDropdownMenu.classList.add('displaying-sublevel');
            }
            // firstLevelButton.nextSibling

            // mh-menu-dropdown-container
        });
    });

    mobileSecondLevelBackButtons.forEach(secondLevelBackButton => {
        secondLevelBackButton.addEventListener('click', e => {
            e.preventDefault();

            const activeSecondLevelMenu = document.querySelectorAll('.active-second-level');
            activeSecondLevelMenu.forEach(activeSecondLevel => {
                activeSecondLevel.classList.remove('active-second-level');
            });

            const firstLevelDropdownMenu = secondLevelBackButton.closest('.mh-menu-dropdown-first-level.displaying-sublevel');
            if (firstLevelDropdownMenu) {
                firstLevelDropdownMenu.classList.remove('displaying-sublevel');
            }
        });
    });

    mobileSecondLevelButtons.forEach(secondLevelButton => {
        secondLevelButton.addEventListener('click', e => {
            e.preventDefault();
            const parentItem = secondLevelButton.parentElement;
            const thirdLevelMenu = parentItem.querySelector('.mh-menu-dropdown-third-level');

            thirdLevelMenu.classList.add('active-third-level');

            const secondLevelDropdownMenu = parentItem.closest('.mh-menu-dropdown-second-level');
            if (secondLevelDropdownMenu) {
                secondLevelDropdownMenu.classList.add('displaying-sublevel');
            }
        });
    });

    mobileThirdLevelBackButtons.forEach(thirdLevelBackButton => {
        thirdLevelBackButton.addEventListener('click', e => {
            e.preventDefault();

            const activeThirdLevelMenu = document.querySelectorAll('.active-third-level');
            activeThirdLevelMenu.forEach(activeThirdLevel => {
                activeThirdLevel.classList.remove('active-third-level');
            });

            const secondLevelDropdownMenu = thirdLevelBackButton.closest('.mh-menu-dropdown-second-level.displaying-sublevel');
            if (secondLevelDropdownMenu) {
                secondLevelDropdownMenu.classList.remove('displaying-sublevel');
            }
        });
    });
};

/* eslint-enable import/prefer-default-export */

document.addEventListener('DOMContentLoaded', MobileHeaderHandler);
